import React from "react";

export const DefaultValueInput = (props) => {
    const {value, onChange} = props;
  return (
      <div className="predicate-box right">
          <div className="type-selector">
              <button>Default value</button>
          </div>
          <input
              type="text"
              value={value}
              onChange={onChange}
          />
      </div>
  )
}